module.exports = __webpack_public_path__ + "img/play-lista.062f1390.svg";